module.exports = __webpack_public_path__ + "static/media/error404.c99e8847.png";